import { secureGet, securePut } from '../utils/HttpUtils';

const apiUrl = '/v1/private/application/commissions/configuration';

export interface CommissionCalculationType {
  id: number;
  code: string;
  label: string;
}

export interface CommissionRateInterval {
  fromMonth: number;
  toMonth: number | null;
  rate: number;
}

export interface CommissionConfigurationRow {
  productLineId: number;
  productLineLabel: string;
  currencyId: number;
  currencyCode: string;
  currencyLabel: string;
  calculationTypeId: number | null;
  expenseRate: number | null;
  intervals: CommissionRateInterval[];
}

export interface CommissionConfigurationSaveRow {
  productLineId: number;
  currencyId: number;
  calculationTypeId: number | null;
  expenseRate: number | null;
  intervals: CommissionRateInterval[];
}

export interface CommissionConfigurationData {
  calculationTypes: CommissionCalculationType[];
  rows: CommissionConfigurationRow[];
}

export interface CommissionConfigurationResponse {
  success: boolean;
  data?: CommissionConfigurationData;
  message?: string;
}

export const getCommissionConfiguration = async (): Promise<CommissionConfigurationResponse> => {
  try {
    const response = await secureGet(apiUrl);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: response.data as CommissionConfigurationData,
      };
    }
    return {
      success: false,
      message: 'Error al obtener la configuración de comisiones',
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.message || 'Error al obtener la configuración de comisiones',
    };
  }
};

export const saveCommissionConfiguration = async (
  rows: CommissionConfigurationSaveRow[],
): Promise<CommissionConfigurationResponse> => {
  try {
    const response = await securePut(apiUrl, { rows });
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: response.data as CommissionConfigurationData,
      };
    }
    return {
      success: false,
      message:
        ('message' in response && typeof response.message === 'string' && response.message) ||
        'Error al guardar la configuración de comisiones',
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.message || 'Error al guardar la configuración de comisiones',
    };
  }
};
